import Flex from 'typescript-styled-flex'
import is, { isNot } from 'typescript-styled-is'
import styled, { ITheme } from '../../../theme'
import isLink from '../../../theme/styles/isLink'

const MenuElement = styled(Flex.withComponent('li') as any)<IMenuElementProps>`
  font-weight: 500;
  min-height: ${({ size }) => (size ? 45 * size : 45)}px;

  width: 100%;
  overflow: hidden;

  ${isLink};

  & > svg {
    stroke-width: 1;
  }

  & > div {
    height: ${({ size }) => (size ? 45 * size : 45)}px;
  }

  &.active {
    color: ${(props: ITheme) => props.theme.colors.primary};
    ${isNot('nested')`
    background-color: ${(props: ITheme) => props.theme.colors.palette.paleGrey};
    `}
    & > div > span {
      color: ${(props: ITheme) => props.theme.colors.primary};
    }
    & > a {
      color: ${(props: ITheme) => props.theme.colors.primary};
    }
    font-weight: bold;
  }

  &:before {
    ${is('active')`
    content: " ";
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    background-color: ${(props: ITheme) => props.theme.colors.palette.emerald};
    transition: all .2s ease-in-out;
    z-index: 2;
  `};
  }

  ${is('open')`
    ${isNot('primary')`
      background-color: ${(props: ITheme) =>
        props.theme.colors.palette.paleGrey};
   `};
`};

  ${isNot('open')`
    max-height: ${({ size }) => (size ? 45 * size : 45)}px;
    overflow: hidden;
`};

  ${isNot('primary')`
    ${is('nested')`
    padding: 0em ${({ size }) => (size ? 1.25 * size : 1.25)}em 0em ${({
      size,
    }) => (size ? size : 1)}em;
  `};
    
@media (min-width: ${(theme: ITheme) => theme.theme.breakpoints.mobile}) {
   &:hover {
      background-color: ${(props: ITheme) =>
        props.theme.colors.palette.paleGrey};
    }
  }
  
 `};
`

export default MenuElement

export interface IMenuElementProps {
  active?: boolean
  open?: boolean
  size?: number
  primary?: boolean
  nested?: boolean
}
